import React from "react";

import { OptisignsAssetBrowser } from "./optisigns-asset-browser";
import { type OptisignsAssetRefSelection } from "./use-optisigns-assets";

interface OptisignsAssetsPanelProps {
  projectId?: string;
  /** Called with the picked assets when the user clicks "Add to message". */
  onSelect: (refs: OptisignsAssetRefSelection[]) => void;
  onBack: () => void;
}

/**
 * User-initiated OptiSigns asset browser (chat composer "+" → OptiSigns Assets).
 * Thin wrapper over the shared {@link OptisignsAssetBrowser} (panel variant) —
 * the same browser the inline chat HITL card uses. Picks are handed back to the
 * composer as @asset reference chips.
 */
export function OptisignsAssetsPanel({
  projectId,
  onSelect,
  onBack,
}: OptisignsAssetsPanelProps): React.ReactElement {
  return (
    <OptisignsAssetBrowser
      variant="panel"
      projectId={projectId}
      onAddToMessage={onSelect}
      onBack={onBack}
    />
  );
}
